var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconToggle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.58579 1.41421C9.36683 0.633165 10.6332 0.633166 11.4142 1.41421L18.9049 8.90492C19.5097 9.50971 19.5097 10.4903 18.9049 11.0951V11.0951C18.3001 11.6999 17.3195 11.6999 16.7148 11.0951L11.4142 5.79454C10.6332 5.0135 9.36683 5.0135 8.58579 5.79455L3.28525 11.0951C2.68045 11.6999 1.69988 11.6999 1.09508 11.0951V11.0951C0.490286 10.4903 0.490286 9.50971 1.09508 8.90492L8.58579 1.41421Z",
    fill: "#89A0BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 18C20 18.5523 19.5523 19 19 19L1 19C0.447715 19 0 18.5523 0 18L0 17C0 16.4477 0.447716 16 1 16L19 16C19.5523 16 20 16.4477 20 17V18Z",
    fill: "#89A0BF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToggle);
export default __webpack_public_path__ + "static/media/icon_toggle.4fe4141041ec5d1e4875a3606fb92ce3.svg";
export { ForwardRef as ReactComponent };